import dayjs from "dayjs";

export const currentMonthYear = dayjs().format("MMM YYYY");
